import React from 'react'
import styled from '@emotion/styled'

import { responsive } from '../../utils/style'
import { css } from '@emotion/react'

import { useNavigate } from 'react-router-dom'

const ReportCard = ({ isStart }) => {
  const navigate = useNavigate()
  return (
    <Container>
      <Rank onClick={() => navigate('/ranking')}>
        <Label>ข้อมูล Ranking</Label>
      </Rank>
      <Report onClick={() => navigate('/report')}>
        <Label>ขอทราบผล</Label>
      </Report>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  max-width: 911px;
  height: 160px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0;

  ${responsive.tablet(css`
    max-width: unset;
    width: calc(100% - 64px);
    height: 120px;
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
    height: 80px;
    margin: 8px 0;
  `)}
`

const Rank = styled.div`
  height: 100%;
  width: 451.5px;
  background-color: ${(props) => (props.disable ? '#E7EAEE' : '#FC6B4B')};
  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: ${(props) => (props.disable ? 'not-allowed' : 'pointer')};

  ${responsive.tablet(css`
    width: calc(100% / 2 - 4px);
  `)}
`

const Report = styled(Rank)`
  background-color: ${(props) => (props.disable ? '#E7EAEE' : '#FFA226')};
`

const Label = styled.span`
  font-family: 'Noto Sans Thai', 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  line-height: 40px;

  letter-spacing: -0.02em;

  color: ${(props) => (props.disable ? '#A0ABBB' : '#ffffff')};

  ${responsive.tablet(css`
    font-size: 28px;
    line-height: 34px;
  `)}

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;
  `)}
`

export default ReportCard
